// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Newsletter_mail__1S3BZ {\n  text-decoration: underline;\n}\n.Newsletter_button__1vtcQ {\n  margin-top: 25px;\n  text-align: center;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Navigation/Newsletter.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".mail {\n  text-decoration: underline;\n}\n.button {\n  margin-top: 25px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mail": "Newsletter_mail__1S3BZ",
	"button": "Newsletter_button__1vtcQ"
};
export default ___CSS_LOADER_EXPORT___;
